import {UntypedFormGroup} from '@angular/forms';

export default class Utils {

  static passwordMatchValidator(g: UntypedFormGroup): void  {
    if(g.get('password').value === g.get('passwordConfirm').value){
      return null;
    }
    g.get('passwordConfirm').setErrors({'mismatch': true});
  }

  static cleanLocalStorage(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('tiers');
    localStorage.removeItem('email');
    localStorage.removeItem('provider');
    localStorage.removeItem('activated');
  }
}
